

export const frontMatter = {
	sidebar_position: 3,
	toc_max_heading_level: 2,
	license: 'republish',
	author: 'Jan van Steenbergen',
	origin: 'http://steen.free.fr/interslavic/pronouns.html',
	description: 'Исследуйте использование, склонение и примеры местоимений в межславянском языке. Изучите личные, возвратные, притяжательные, указательные, относительные, вопросительные и неопределенные местоимения.',
	tags: [
		'межславянский',
		'местоимения',
		'грамматика',
		'изучение языка'
	],
	verified: true
};
export const contentTitle = 'Местоимения';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-i-18-n-ru-docusaurus-plugin-content-docs-current-learn-grammar-pronouns-md-35f.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Личные и возвратные местоимения",
  "id": "personal-and-reflexive-pronouns",
  "level": 2
}, {
  "value": "Притяжательные местоимения",
  "id": "possessive-pronouns",
  "level": 2
}, {
  "value": "Указательные местоимения",
  "id": "demonstrative-pronouns",
  "level": 2
}, {
  "value": "Примечания",
  "id": "примечания",
  "level": 3
}, {
  "value": "Относительные местоимения",
  "id": "relative-pronouns",
  "level": 2
}, {
  "value": "Вопросительные местоимения",
  "id": "interrogative-pronouns",
  "level": 2
}, {
  "value": "Неопределенные местоимения",
  "id": "indefinite-pronouns",
  "level": 2
}, {
  "value": "Местоименные наречия",
  "id": "pronominal-adverbs",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    abbr: "abbr",
    admonition: "admonition",
    em: "em",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    header: "header",
    li: "li",
    ol: "ol",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {CustomAfterSection, CustomBeforeSection, MDPronouns1, MDPronouns2, MDPronouns3, MDPronouns4, MDPronouns5, MDPronouns6, TransliteratorElement} = _components;
  if (!CustomAfterSection) _missingMdxReference("CustomAfterSection", true);
  if (!CustomBeforeSection) _missingMdxReference("CustomBeforeSection", true);
  if (!MDPronouns1) _missingMdxReference("MDPronouns1", true);
  if (!MDPronouns2) _missingMdxReference("MDPronouns2", true);
  if (!MDPronouns3) _missingMdxReference("MDPronouns3", true);
  if (!MDPronouns4) _missingMdxReference("MDPronouns4", true);
  if (!MDPronouns5) _missingMdxReference("MDPronouns5", true);
  if (!MDPronouns6) _missingMdxReference("MDPronouns6", true);
  if (!TransliteratorElement) _missingMdxReference("TransliteratorElement", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "местоимения",
        children: "Местоимения"
      })
    }), "\n", _jsx(_components.h2, {
      id: "personal-and-reflexive-pronouns",
      children: "Личные и возвратные местоимения"
    }), "\n", _jsx(CustomBeforeSection, {}), "\n", _jsxs(_components.p, {
      children: ["Личные местоимения имеют шесть падежей — такие же, как и существительные, но без звательного падежа. Возвратное местоимение ", _jsx(TransliteratorElement, {
        children: "sebe"
      }), " склоняется как ", _jsx(TransliteratorElement, {
        children: "ty"
      }), ", ", _jsx(TransliteratorElement, {
        children: "tebe"
      }), ", ..., единственное отличие заключается в том, что оно не имеет именительного падежа."]
    }), "\n", _jsxs(_components.p, {
      children: ["Формы в скобках являются клитическими формами, то есть они слабее и всегда безударны. ", _jsx(TransliteratorElement, {
        children: "Se"
      }), " используется в возвратных глаголах: ", _jsx(TransliteratorElement, {
        children: "Ja myju se"
      }), " \"Я моюсь\". Если нужно сделать ударение, используется более длинная форма: ", _jsx(TransliteratorElement, {
        children: "Ja myju jedino sebe"
      }), " \"Я мою только себя\". После предлога лучше использовать более длинные формы: ", _jsx(TransliteratorElement, {
        children: "k mně"
      }), ", ", _jsx(TransliteratorElement, {
        children: "za tebe"
      }), "."]
    }), "\n", _jsx(MDPronouns1, {}), "\n", _jsxs(_components.admonition, {
      title: "Примечания",
      type: "note",
      children: [_jsxs(_components.p, {
        children: ["После предлога все местоимения третьего лица имеют префикс ", _jsx(TransliteratorElement, {
          children: "n-"
        }), ": ", _jsx(TransliteratorElement, {
          children: "jego"
        }), " > ", _jsx(TransliteratorElement, {
          children: "do njego"
        }), "; ", _jsx(TransliteratorElement, {
          children: "jim"
        }), " > ", _jsx(TransliteratorElement, {
          children: "pri njim"
        }), ", и т.д. (по этой причине формы местного падежа ", _jsx(TransliteratorElement, {
          children: "jim"
        }), ", ", _jsx(TransliteratorElement, {
          children: "jej"
        }), " и ", _jsx(TransliteratorElement, {
          children: "jih"
        }), " никогда не употребляются, поскольку местному падежу всегда предшествует предлог)"]
      }), _jsxs(_components.p, {
        children: ["Если вам интересно, как эти формы соотносятся со славянскими языками, вы можете увидеть их сравнение ", _jsx(_components.a, {
          href: "http://steen.free.fr/interslavic/slavic_pronouns.html",
          children: "здесь"
        }), "."]
      })]
    }), "\n", _jsx(_components.p, {
      children: "Несколько дополнительных замечаний по употреблению:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Поскольку не все глагольные окончания одинаково очевидны для всех носителей славянских языков, не рекомендуется опускать личные местоимения, когда они являются подлежащим предложения. Лучше сказать ", _jsx(TransliteratorElement, {
          children: "ja čitaju"
        }), ", чем просто ", _jsx(TransliteratorElement, {
          children: "čitaju"
        }), ", хотя последнее также не является неправильным."]
      }), "\n", _jsx(_components.li, {
        children: "Предлоги могут управлять любым падежом, кроме именительного, в зависимости от их употребления в славянских языках."
      }), "\n", _jsxs(_components.li, {
        children: ["Местоимение ", _jsx(TransliteratorElement, {
          children: "on"
        }), " относится к любому существительному мужского рода, а не только к одушевленным существам мужского пола. Так же местоимение ", _jsx(TransliteratorElement, {
          children: "ona"
        }), " относится к любому существительному женского рода, а не только к одушевленным существам женского пола."]
      }), "\n", _jsxs(_components.li, {
        children: ["Как и все естественные славянские языки, межславянский имеет различение T-V, то есть ", _jsx(TransliteratorElement, {
          children: "vy"
        }), " является универсальным местоимением второго лица для обоих чисел, в то время как второе лицо единственного числа ", _jsx(TransliteratorElement, {
          children: "ty"
        }), " используется только для обращения к друзьям, родственникам и детям."]
      }), "\n", _jsxs(_components.li, {
        children: ["Возвратное местоимение также может использоваться как взаимное местоимение: ", _jsx(TransliteratorElement, {
          children: "Oni bijut se"
        }), " может означать \"Они бьют себя\", но чаще имеет значение: \"Они бьют друг друга\". Чтобы четче выразить значение \"друг друга\", можно добавить формулу ", _jsx(TransliteratorElement, {
          children: "jedin drugogo"
        }), ", например: ", _jsx(TransliteratorElement, {
          children: "Oni bijut se jedin drugogo"
        }), "."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "possessive-pronouns",
      children: "Притяжательные местоимения"
    }), "\n", _jsx(_components.p, {
      children: "Притяжательные местоимения склоняются как прилагательные, за исключением нулевого окончания в мужском роде единственного числа. Формы следующие:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "moj"
        }), ", ", _jsx(TransliteratorElement, {
          children: "moja"
        }), ", ", _jsx(TransliteratorElement, {
          children: "moje"
        }), " — мой, моя, моё"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "tvoj"
        }), ", ", _jsx(TransliteratorElement, {
          children: "tvoja"
        }), ", ", _jsx(TransliteratorElement, {
          children: "tvoje"
        }), " — твой, твоя, твоё"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "naš"
        }), ", ", _jsx(TransliteratorElement, {
          children: "naša"
        }), ", ", _jsx(TransliteratorElement, {
          children: "naše"
        }), " — наш, наша, наше"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "vaš"
        }), ", ", _jsx(TransliteratorElement, {
          children: "vaša"
        }), ", ", _jsx(TransliteratorElement, {
          children: "vaše"
        }), " — ваш, ваша, ваше"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "svoj"
        }), ", ", _jsx(TransliteratorElement, {
          children: "svoja"
        }), ", ", _jsx(TransliteratorElement, {
          children: "svoje"
        }), " — свой, своя, своё"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["В третьем лице чаще всего используется родительный падеж соответствующего личного местоимения: ", _jsx(TransliteratorElement, {
        children: "jego"
      }), ", ", _jsx(TransliteratorElement, {
        children: "jej"
      }), ", ", _jsx(TransliteratorElement, {
        children: "jih"
      }), ". Эти формы не склоняются. Альтернативно можно также использовать следующие формы, которые склоняются как прилагательные:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "jegov"
        }), ", ", _jsx(TransliteratorElement, {
          children: "jegova"
        }), ", ", _jsx(TransliteratorElement, {
          children: "jegovo"
        }), " — его"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "jejin"
        }), ", ", _jsx(TransliteratorElement, {
          children: "jejina"
        }), ", ", _jsx(TransliteratorElement, {
          children: "jejino"
        }), " — её"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "jihny"
        }), ", ", _jsx(TransliteratorElement, {
          children: "jihna"
        }), ", ", _jsx(TransliteratorElement, {
          children: "jihno"
        }), " — их"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Когда владелец также является подлежащим предложения, используется возвратное местоимение ", _jsx(TransliteratorElement, {
        children: "svoj"
      }), ", независимо от того, находится ли подлежащее в третьем лице или нет: ", _jsx(TransliteratorElement, {
        children: "Ja myju svoje avto"
      }), " \"Я мою свою машину\". Обратите внимание на разницу в значении, когда возвратное местоимение относится к подлежащему в третьем лице:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "Pjotr dal Ivanu svoju knigu"
        }), " — Петр дал Ивану свою [= Петрову] книгу"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "Pjotr dal Ivanu jegovu knigu"
        }), " — Петр дал Ивану его [= Иванову] книгу"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Существуют также вопросительные, определенные и неопределенные притяжательные местоимения: ", _jsx(TransliteratorElement, {
        children: "čij"
      }), " (чей), ", _jsx(TransliteratorElement, {
        children: "ničij"
      }), " (ничей), ", _jsx(TransliteratorElement, {
        children: "něčij"
      }), " (чей-то) и т.д. Они склоняются как ", _jsx(TransliteratorElement, {
        children: "moj"
      }), ". Для других форм смотрите раздел о ", _jsx(_components.a, {
        href: "#pronominal-adverbs",
        children: "соотносительных словах"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Как и прилагательные, притяжательные местоимения согласуются с существительным, которое они определяют, в роде, числе и падеже. За исключением мужского рода в именительном и винительном падежах единственного числа, их склонение идентично склонению прилагательных: ", _jsx(TransliteratorElement, {
        children: "moj"
      }), ", ", _jsx(TransliteratorElement, {
        children: "tvoj"
      }), ", ", _jsx(TransliteratorElement, {
        children: "naš"
      }), ", ", _jsx(TransliteratorElement, {
        children: "vaš"
      }), ", ", _jsx(TransliteratorElement, {
        children: "svoj"
      }), " и ", _jsx(TransliteratorElement, {
        children: "čij"
      }), " — как ", _jsx(TransliteratorElement, {
        children: "svěži"
      }), "; ", _jsx(TransliteratorElement, {
        children: "jegov"
      }), ", ", _jsx(TransliteratorElement, {
        children: "jejin"
      }), " и ", _jsx(TransliteratorElement, {
        children: "jihny"
      }), " — как ", _jsx(TransliteratorElement, {
        children: "dobry"
      }), "):"]
    }), "\n", _jsx(MDPronouns2, {}), "\n", _jsx(_components.h2, {
      id: "demonstrative-pronouns",
      children: "Указательные местоимения"
    }), "\n", _jsxs(_components.p, {
      children: ["Основным указательным местоимением является ", _jsx(TransliteratorElement, {
        children: "toj"
      }), " (этот, тот), и его следует использовать, когда нет необходимости четко различать \"этот здесь\" и \"тот там\"."]
    }), "\n", _jsxs(_components.p, {
      children: ["Если нам нужно быть точнее, самым простым решением является использование ", _jsx(TransliteratorElement, {
        children: "tutoj"
      }), " для \"этот\" и ", _jsx(TransliteratorElement, {
        children: "tamtoj"
      }), " для \"тот, вон тот\". Они склоняются следующим образом:"]
    }), "\n", _jsx(MDPronouns3, {}), "\n", _jsx(_components.h3, {
      id: "примечания",
      children: "Примечания"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Менее простым, но исторически более точным является следующее трехсоставное различение: ", _jsx(TransliteratorElement, {
          children: "sej"
        }), " (", _jsx(_components.abbr, {
          title: "женский род",
          children: "ж.р."
        }), " ", _jsx(TransliteratorElement, {
          children: "sa"
        }), ", ", _jsx(_components.abbr, {
          title: "средний род",
          children: "с.р."
        }), " ", _jsx(TransliteratorElement, {
          children: "se"
        }), ") для \"этот\", ", _jsx(TransliteratorElement, {
          children: "toj"
        }), " для \"тот\" и ", _jsx(TransliteratorElement, {
          children: "onoj"
        }), " для \"вон тот\". Следует помнить, однако, что ", _jsx(TransliteratorElement, {
          children: "sej"
        }), " практически исчез из большинства современных языков, за исключением нескольких окаменелых остатков. Поэтому он может быть не всегда понятен."]
      }), "\n", _jsxs(_components.li, {
        children: ["Другое указательное местоимение - это ", _jsx(TransliteratorElement, {
          children: "ov"
        }), ", что означает то же самое, что и ", _jsx(TransliteratorElement, {
          children: "sej"
        }), ". Однако его значение очень различается в современных языках."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "Tutoj"
        }), ", ", _jsx(TransliteratorElement, {
          children: "tamtoj"
        }), ", ", _jsx(TransliteratorElement, {
          children: "ov"
        }), " и ", _jsx(TransliteratorElement, {
          children: "onoj"
        }), " склоняются как ", _jsx(TransliteratorElement, {
          children: "toj"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Вместо форм множественного числа ", _jsx(TransliteratorElement, {
          children: "tyh"
        }), ", ", _jsx(TransliteratorElement, {
          children: "tym"
        }), " и ", _jsx(TransliteratorElement, {
          children: "tymi"
        }), " иногда можно встретить ", _jsx(TransliteratorElement, {
          children: "těh"
        }), ", ", _jsx(TransliteratorElement, {
          children: "těm"
        }), " и ", _jsx(TransliteratorElement, {
          children: "těmi"
        }), "."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "relative-pronouns",
      children: "Относительные местоимения"
    }), "\n", _jsxs(_components.p, {
      children: ["Наиболее часто используемым относительным местоимением является ", _jsx(TransliteratorElement, {
        children: "ktory"
      }), ". Оно склоняется как обычное прилагательное. Альтернативно можно использовать южнославянское ", _jsx(TransliteratorElement, {
        children: "koj"
      }), " (склоняется как ", _jsx(TransliteratorElement, {
        children: "moj"
      }), "). Их значения идентичны, и они могут использоваться взаимозаменяемо."]
    }), "\n", _jsxs(_components.p, {
      children: ["Третьим вариантом является более архаичное ", _jsx(TransliteratorElement, {
        children: "iže"
      }), " – используется в именительном падеже для всех родов, как в единственном, так и во множественном числе; в других падежах склоняется как форма личного местоимения ", _jsx(TransliteratorElement, {
        children: "on"
      }), "/", _jsx(TransliteratorElement, {
        children: "ona"
      }), "/", _jsx(TransliteratorElement, {
        children: "ono"
      }), " с суффиксом ", _jsx(TransliteratorElement, {
        children: "-že"
      }), ": ", _jsx(TransliteratorElement, {
        children: "jegože"
      }), " (", _jsx(_components.abbr, {
        title: "мужской род, родительный падеж, единственное число",
        children: "м.р. род. ед.ч."
      }), "), ", _jsx(TransliteratorElement, {
        children: "jemuže"
      }), " (", _jsx(_components.abbr, {
        title: "мужской род, дательный падеж, единственное число",
        children: "м.р. дат. ед.ч."
      }), ") и т.д."]
    }), "\n", _jsx(_components.h2, {
      id: "interrogative-pronouns",
      children: "Вопросительные местоимения"
    }), "\n", _jsxs(_components.p, {
      children: ["Вопросительными местоимениями являются ", _jsx(TransliteratorElement, {
        children: "kto"
      }), " (кто) и ", _jsx(TransliteratorElement, {
        children: "čto"
      }), " (или ", _jsx(TransliteratorElement, {
        children: "što"
      }), ") (что). Они склоняются следующим образом:"]
    }), "\n", _jsx(MDPronouns4, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "кто?"
        }), "\n", _jsx(_components.li, {
          children: "что?"
        }), "\n"]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Вопросительные определения - это ", _jsx(TransliteratorElement, {
        children: "koj"
      }), " (склоняется как ", _jsx(TransliteratorElement, {
        children: "moj"
      }), ") (какой) (вместо него также можно использовать ", _jsx(TransliteratorElement, {
        children: "ktory"
      }), "), притяжательное местоимение ", _jsx(TransliteratorElement, {
        children: "čij"
      }), " (чей) (см. выше) и прилагательное ", _jsx(TransliteratorElement, {
        children: "kaky"
      }), " (какой)."]
    }), "\n", _jsx(_components.h2, {
      id: "indefinite-pronouns",
      children: "Неопределенные местоимения"
    }), "\n", _jsx(_components.p, {
      children: "Это большая группа местоимений и определений, большинство из которых регулярно образуются от вопросительных местоимений. Существует несколько категорий:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Относящиеся ко всем предметам (универсальные) (", _jsx(TransliteratorElement, {
            children: "vs-"
          }), "): ", _jsx(TransliteratorElement, {
            children: "vsi"
          }), " или ", _jsx(TransliteratorElement, {
            children: "vsekto"
          }), " (все, каждый), ", _jsx(TransliteratorElement, {
            children: "vse"
          }), " или ", _jsx(TransliteratorElement, {
            children: "vsečto"
          }), " (всё); ", _jsx(TransliteratorElement, {
            children: "ves"
          }), " (", _jsx(_components.abbr, {
            title: "женский род",
            children: "ж.р."
          }), " ", _jsx(TransliteratorElement, {
            children: "vsa"
          }), ", ", _jsx(_components.abbr, {
            title: "средний род",
            children: "с.р."
          }), " ", _jsx(TransliteratorElement, {
            children: "vse"
          }), " (целый, весь; все)); ", _jsx(TransliteratorElement, {
            children: "cěly"
          }), " (целый, весь); ", _jsx(TransliteratorElement, {
            children: "vsaky"
          }), " (каждый, всякий); ", _jsx(TransliteratorElement, {
            children: "vsekaky"
          }), " (всякого рода, всех видов); ", _jsx(TransliteratorElement, {
            children: "vsečij"
          }), " (всехний)."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Относящиеся ни к одному предмету (отрицательные) (", _jsx(TransliteratorElement, {
            children: "ni-"
          }), "): ", _jsx(TransliteratorElement, {
            children: "nikto"
          }), " (никто), ", _jsx(TransliteratorElement, {
            children: "ničto"
          }), " (ничто), ", _jsx(TransliteratorElement, {
            children: "nikoj"
          }), ", ", _jsx(TransliteratorElement, {
            children: "nijedin"
          }), " и ", _jsx(TransliteratorElement, {
            children: "nikaky"
          }), " (ни один, никакой), ", _jsx(TransliteratorElement, {
            children: "ničij"
          }), " (ничей)."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Относящиеся к одному неопределенному предмету (", _jsx(TransliteratorElement, {
            children: "ně-"
          }), "): ", _jsx(TransliteratorElement, {
            children: "někto"
          }), " (кто-то), ", _jsx(TransliteratorElement, {
            children: "něčto"
          }), " (что-то), ", _jsx(TransliteratorElement, {
            children: "někoj"
          }), " (какой-то), ", _jsx(TransliteratorElement, {
            children: "někaky"
          }), " (какого-то рода), ", _jsx(TransliteratorElement, {
            children: "něčij"
          }), " (чей-то)."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Относящиеся к нескольким неопределенным предметам (", _jsx(TransliteratorElement, {
            children: "poně–"
          }), "): ", _jsx(TransliteratorElement, {
            children: "poněkoj"
          }), " (некоторые, несколько), ", _jsx(TransliteratorElement, {
            children: "poněkaky"
          }), " (нескольких видов)."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Относящиеся к большой группе предметов: ", _jsx(TransliteratorElement, {
            children: "mnogy"
          }), " (много, многочисленный)."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Что касаются любого члена группы (", _jsx(TransliteratorElement, {
            children: "-koli"
          }), ", ", _jsx(TransliteratorElement, {
            children: "-nebud"
          }), ", ", _jsx(TransliteratorElement, {
            children: "libo-"
          }), "): ", _jsx(TransliteratorElement, {
            children: "ktokoli"
          }), ", ", _jsx(TransliteratorElement, {
            children: "libokto"
          }), ", ", _jsx(TransliteratorElement, {
            children: "kto-nebud"
          }), " (кто-либо, кто-нибудь), ", _jsx(TransliteratorElement, {
            children: "čtokoli"
          }), ", ", _jsx(TransliteratorElement, {
            children: "libočto"
          }), ", ", _jsx(TransliteratorElement, {
            children: "čto-nebud"
          }), " (что-либо); ", _jsx(TransliteratorElement, {
            children: "kojkoli"
          }), ", ", _jsx(TransliteratorElement, {
            children: "libokoj"
          }), ", ", _jsx(TransliteratorElement, {
            children: "koj-nebud"
          }), " (какой-либо), ", _jsx(TransliteratorElement, {
            children: "kakykoli"
          }), ", ", _jsx(TransliteratorElement, {
            children: "libokaky"
          }), ", ", _jsx(TransliteratorElement, {
            children: "kaky-nebud"
          }), " (какого-либо рода); ", _jsx(TransliteratorElement, {
            children: "čijkoli"
          }), ", ", _jsx(TransliteratorElement, {
            children: "libočij"
          }), ", ", _jsx(TransliteratorElement, {
            children: "čij-nebud"
          }), " (чей-либо). Для обозначения безразличия можно использовать наречие ", _jsx(TransliteratorElement, {
            children: "bylo"
          }), ": ", _jsx(TransliteratorElement, {
            children: "bylo kto"
          }), " (кто угодно), ", _jsx(TransliteratorElement, {
            children: "bylo čto"
          }), " (что угодно) и т.д."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Что касаются другого предмета группы (", _jsx(TransliteratorElement, {
            children: "in-"
          }), "): ", _jsx(TransliteratorElement, {
            children: "inokto"
          }), " (кто-то другой), ", _jsx(TransliteratorElement, {
            children: "inočto"
          }), " (что-то другое), ", _jsx(TransliteratorElement, {
            children: "iny"
          }), " (иной), ", _jsx(TransliteratorElement, {
            children: "inočij"
          }), " (чей-то другой)."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(TransliteratorElement, {
        children: "Vsekto"
      }), ", ", _jsx(TransliteratorElement, {
        children: "nikto"
      }), ", ", _jsx(TransliteratorElement, {
        children: "něčto"
      }), ", ", _jsx(TransliteratorElement, {
        children: "čtokoli"
      }), " и т.д. склоняются как ", _jsx(TransliteratorElement, {
        children: "kto"
      }), " и ", _jsx(TransliteratorElement, {
        children: "čto"
      }), ". Также ", _jsx(TransliteratorElement, {
        children: "nikoj"
      }), ", ", _jsx(TransliteratorElement, {
        children: "něčij"
      }), " и т.д. склоняются как ", _jsx(TransliteratorElement, {
        children: "koj"
      }), " и ", _jsx(TransliteratorElement, {
        children: "čij"
      }), " (и следовательно, как ", _jsx(TransliteratorElement, {
        children: "moj"
      }), "). ", _jsx(TransliteratorElement, {
        children: "Ves"
      }), " (весь) склоняется следующим образом:"]
    }), "\n", _jsx(MDPronouns5, {}), "\n", _jsx(_components.h2, {
      id: "pronominal-adverbs",
      children: "Местоименные наречия"
    }), "\n", _jsxs(_components.p, {
      children: ["Одним из лучших изобретений Заменгофа была его ", _jsx(_components.strong, {
        children: "таблица соотносимых слов"
      }), ", группа взаимосвязанных местоимений, прилагательных и наречий. Эти слова были сохранены максимально регулярными, но не за счет узнаваемости для носителей славянских языков. Некоторые практически невозможные слова были пропущены, а некоторые другие регулярные формы были заменены формами, которые распространены в естественных языках. Нерегулярные формы (то есть те, что не выглядят так, как должны были бы согласно таблице) показаны ", _jsx(_components.em, {
        children: _jsx(_components.strong, {
          children: "курсивом"
        })
      }), "."]
    }), "\n", _jsx(MDPronouns6, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "вопрос; здесь; там; вон там; какой-то; несколько; любой; ни; каждый; другой;"
        }), "\n", _jsx(_components.li, {
          children: "какой? кто? что? сколько? чей? какой? как? где? куда? когда? куда? откуда? зачем (цель)? почему (причина)?"
        }), "\n"]
      })
    }), "\n", _jsx(_components.admonition, {
      title: "Примечания",
      type: "note",
      children: _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["Во всех случаях, когда появляется ", _jsx(TransliteratorElement, {
            children: "koj"
          }), ", можно использовать ", _jsx(TransliteratorElement, {
            children: "ktory"
          }), "."]
        }), "\n", _jsxs(_components.li, {
          children: ["Во всех случаях, когда появляется ", _jsx(TransliteratorElement, {
            children: "-gda"
          }), ", можно использовать ", _jsx(TransliteratorElement, {
            children: "-gdy"
          }), "."]
        }), "\n"]
      })
    }), "\n", _jsx(CustomAfterSection, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

